import { useBreakpoint } from 'src/utils/hooks/useBreakpoint'

export const useNarrowScreenForArtworkDetail = (isSinglePage?: boolean) => {
  const isLg = useBreakpoint('lg')
  const isMmd = useBreakpoint('mmd')
  return isSinglePage ? isLg : isMmd
}
